import { Routes, Route } from 'react-router-dom';
import Landing from './apps/landing/Landing';
import HungerGamesApp from './apps/hunger-games/HungerGamesApp';
import MissingWallApp from './apps/missing-wall/MissingWallApp';
import ReportApp from './apps/report/ReportApp';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/hunger-games/*" element={<HungerGamesApp />} />
      <Route path="/lost-ones" element={<MissingWallApp />} />
      <Route path="/css-animation/*" element={<ReportApp />} />
    </Routes>
  );
}
